import { render, staticRenderFns } from "./FamilyMeta.vue?vue&type=template&id=6e042238&scoped=true"
import script from "./FamilyMeta.vue?vue&type=script&lang=js"
export * from "./FamilyMeta.vue?vue&type=script&lang=js"
import style0 from "./FamilyMeta.vue?vue&type=style&index=0&id=6e042238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e042238",
  null
  
)

export default component.exports